import fetch from '../config/fetch'

/**
 * 微信appid
 */
export const APPID = "wx844697a27148c8ff";

/**
 * 获取首页数据
 */
export const getHome = params => fetch('mini3/H5WAppMain.do', params, 'get');

/**
 * 获取首页热门城市数据
 */
export const getHotCity= params => fetch('mini3/hotCity.do', params, 'get');

/**
 * 获取首页语音数据
 */
export const getHomeBag= params => fetch('mini3/homeBag.do', params, 'get');

/**
 * 获取首页语音数据
 */
export const getSpecialRoot= params => fetch('mini3/specialRoot.do', params, 'get');

/**
 * 获取景区详情数据
 */
export const getViewDetail = params => fetch('voiceBagList/getH5ShopVBList.do', params, 'get');

/**
 * 获取景区页面360全景数据
 */
export const getViewVr = params => fetch('voiceBagList/getVRBag.do', params, 'get');

/**
 * 获取景点详情数据
 */
export const getSpotDetail = params => fetch('voiceBagList/getH5SpotVBList.do', params, 'get');

/**
 * 获取专辑详情数据
 */
export const getBagTab = params => fetch('minimap/getBagTab.do', params, 'get');

/**
 * 获取专辑评论数据
 */
export const getBagComment = params => fetch('bagcomment.do', params, 'get');

/**
 * 给评论点赞提交
 */
export const getZan = params => fetch('zan.do', params, 'get');

/**
 * 获取景区景点详情目录弹窗数据
 */
export const getCatalogue = params => fetch('getAllShopSpotList.do', params, 'get');

/**
 * 获取景区景点详情目录弹窗数据
 */
export const getVideoPlay = params => fetch('getVoiceBagDetail.do', params, 'get');

/**
 * 获取景区景点详情目录弹窗数据(视频)
 */
export const getVideoPlayView = params => fetch('voiceBagList/getVoiceBagDetail.do', params, 'get');

/**
 * 获取版权申明
 */
export const getAgreement = params => fetch('getProtocol.do', params, 'get');

/**
 * 获取收听历史
 */
export const getListenHistory = params => fetch('userHistory.do', params, 'get');

/**
 * 获取已购列表
 */
export const getPurchase = params => fetch('myOrder.do', params, 'get');

/**
 * 获取个人中心消息数
 */
export const getNoticeNumber = params => fetch('getNoticeNumber.do', params, 'get');

/**
 * 获取用户认证信息
 */
export const getUserRZ = params => fetch('getUserRZ.do', params, 'get');

/**
 * 获取定位城市信息
 */
export const getCityCode = params => fetch('getCityCode.do', params, 'get');

/**
 * 获取意见反馈接口
 */
export const getFeedback = params => fetch('userfeedback.do', params, 'get');

/**
 * 获取城市列表接口
 */
export const getCityList = params => fetch('getCityList.do', params, 'get');

/**
 * 获取我的评论接口
 */
export const getMyComment = params => fetch('getMyComment.do', params, 'get');

/**
 * 删除我的评论接口
 */
export const deleteComment = params => fetch('deleteComment.do', params, 'get');


/**
 * 获取导游简介接口
 */
export const getGuideinfo = params => fetch('guideinfo.do', params, 'get');


/**
 * 上传扫码信息接口
 */
export const uploadScan = params => fetch('uploadScan.do', params, 'get');


/**
 * 获取红包活动接口
 */
export const getEnvelope = params => fetch('activityApi/haveActivity.do', params, 'get');


/**
 * 获取人物推荐接口
 */
export const getUserTui = params => fetch('wxguide/getUserTui.do', params, 'get');

/**
 * 获取我的优惠券接口
 */
export const getCoupon = params => fetch('couponApi/getAwardRecordList.do', params, 'get');

/**
 * 记录浏览次数
 */
export const uploadUserBrowse = params => fetch('authUserBrowse.do', params, 'get');

/**
 * 景区景点弹出提示用户购买弹窗接口
 */
export const getNotice = params => fetch('sysNotice/getNotice.do', params, 'get');

/**
 * 生成景区海报
 */
export const getShopPoster = params => fetch('sharePort/shop.do', params, 'get');

/**
 * 生成景点海报
 */
export const getSpotPoster = params => fetch('sharePort/spot.do', params, 'get');

/**
 * 生成导游海报
 */
export const getGuidePoster = params => fetch('sharePort/voiceBag.do', params, 'get');

/**
 * 评论弹幕接口
 */
export const getPopComment = params => fetch('popComment.do', params, 'get');

/**
 * 获取短信验证码接口
 */
export const getTelYzm = params => fetch('getCommoncode.do', params, 'get');

/**
 * 获取推广二维码接口
 */
export const getQRcode = params => fetch('authChannel/getQRcode.do', params, 'get');

/**
 * 获取推广链接接口
 */
export const getUrl = params => fetch('authChannel/getUrl.do', params, 'get');

/**
 * 获取我的账户余额
 */
export const getWallent = params => fetch('userwallent.do', params, 'get');

/**
 * 判断推广账户是否注册
 */
export const getIsRegister = params => fetch('authChannel/isRegister.do', params, 'get');

/**
 * 获取OTA激活码
 */
export const getOTAcode = params => fetch('authChannel/decode.do', params, 'post');

/**
 * 激活OTA码
 */
export const activeOTAcode = params => fetch('activate.do', params, 'post');

/**
 * 获取首页景区数据
 */
export const getIndex = params => fetch('mini3/H5Index.do', params, 'get');

/**
 * 获取研学活动首页数据
 */
export const getStudyIndex = params => fetch('plugin/index.do', params, 'get');

/**
 * 获取研学证书数据
 */
export const certificateList = params => fetch('plugin/certificateList.do', params, 'get');

/**
 * 判断研学活动是否注册过
 */
export const studyIsLogin = params => fetch('plugin/isBind.do', params, 'get');

/**
 * 获取研学活动列表页面数据
 */
export const getStudyList = params => fetch('plugin/home.do', params, 'get');

/**
 * 获取研学活动景区页面数据
 */
export const getStudyInfo = params => fetch('plugin/shop.do', params, 'get');


/**
 * 获取研学活动题目数据
 */
export const getQuestion = params => fetch('plugin/question.do', params, 'get');

/**
 * 获取研学活动打卡列表数据
 */
export const getSignList = params => fetch('plugin/signList.do', params, 'get');

/**
 * 获取研学活动回答问题数据
 */
export const getAnswer = params => fetch('plugin/answer.do', params, 'get');

/**
 * 研学活动重新答题
 */
export const getReset = params => fetch('plugin/reset.do', params, 'get');

/**
 * 获取导游列表（新版）
 */
export const getGuides = params => fetch('mini3/getGuides.do', params, 'get');

/**
 * 获取城市名片详情
 */
export const getCardinfo = params => fetch('getcardinfo.do', params, 'get');

/**
 * 获取附近的景区
 */
export const getNear = params => fetch('mini3/getNearShop.do', params, 'get');





/**
 * 地图：获取全国景区列表
 */
export const mapIndex = params => fetch('map/index.do', params, 'get');

/**
 * 地图：获取景区信息+景点列表
 */
export const mapShop = params => fetch('map/shop.do', params, 'get');

/**
 * 地图：获取景点信息
 */
export const mapSpot = params => fetch('map/spot.do', params, 'get');

/**
 * 地图：获取景区或景点专辑类型
 */
export const mapBagTab = params => fetch('map/vocBagTab.do', params, 'get');

/**
 * 地图：获取景区或景点专辑数据
 */
export const mapBagList = params => fetch('map/vocBagList.do', params, 'get');

/**
 * 地图：导游专辑详情
 */
export const mapBagDetail = params => fetch('map/vocBagDetail.do', params, 'get');

/**
 * 地图：搜索关键词
 */
export const mapSearch = params => fetch('map/search.do', params, 'get');

/**
 * 地图：景区线路
 */
export const mapPolyline = params => fetch('mini3/getPolyline.do', params, 'get');

/**
 * 瀑布流：全部导游
 */
export const getGuide = params => fetch('voiceBagList/getAllGuide.do', params, 'get');

/**
 * 城市站点：首页
 * */
export const citySiteIndex = params => fetch('citySite/index.do', params, 'get');

/**
 * 城市站点：VR列表
 * */
export const citySiteVR = params => fetch('citySite/video.do', params, 'get');

/**
 * 城市站点：附近推荐（线路）列表
 * */
export const citySiteRoot = params => fetch('citySite/root.do', params, 'get');


/**
 * 城市站点：博物馆列表
 * */
export const citySiteMuseum = params => fetch('citySite/museum.do', params, 'get');

/**
 * 城市站点：美食列表
 * */
export const citySiteFood = params => fetch('citySite/food.do', params, 'get');

/**
 * 城市站点：美食详情
 * */
export const citySiteFoodDetail = params => fetch('citySite/foodDetail.do', params, 'get');

/**
 * 城市站点：美食详情点赞
 * */
export const citySiteFoodZan = params => fetch('vocbagZan.do', params, 'get');

/**
 * 城市站点：人文列表
 * */
export const citySiteHistory = params => fetch('citySite/vocBag.do', params, 'get');

/**
 * 城市站点：景区列表
 * */
export const citySiteView = params => fetch('citySite/shop.do', params, 'get');

/**
 * 城市站点：线路推荐图文详情
 * */
export const citySiteRootDetail = params => fetch('citySite/rootDetail.do', params, 'get');

/**
 * 博物馆临展：临展详情
 * */
export const pavilionDetail = params => fetch('pavilion/getPavilionDetail.do', params, 'get');

/**
 * 博物馆临展：临展全部图片
 * */
export const pavilionImgs = params => fetch('pavilion/getAllImage.do', params, 'get');

/**
 * 佛教寺庙：景区详情
 * */
export const getViewDetailSm = params => fetch('voiceBagList/getBuddhismList.do', params, 'get');

/**
 * 佛教寺庙：景点目录
 * */
export const getCatalogueSm = params => fetch('getBuddhismShopSpotList.do', params, 'get');


/**
 * 视频专辑：获取视频列表
 * */
export const getVideoList = params => fetch('product/video.do', params, 'get');

/**
 * 视频专辑：获取视频专辑信息
 * */
export const getVideoInfo = params => fetch('product/bag.do', params, 'get');

/**
 * 视频专辑：视频点赞
 * */
export const videoZan = params => fetch('product/zan.do', params, 'get');

/**
 * 视频专辑：视频分享、播放统计数据
 * */
export const videoCount = params => fetch('product/count.do', params, 'get');

/**
 * 视频专辑：获取视频评论列表
 * */
export const videoComments = params => fetch('product/comments.do', params, 'get');

/**
 * 视频专辑：视频评论
 * */
export const videoComment = params => fetch('product/comment.do', params, 'post');

/**
 * 视频专辑：视频评论回复
 * */
export const videoReply = params => fetch('product/reply.do', params, 'get');

/**
 * 视频专辑：景点目录
 * */
export const getVideoSpots = params => fetch('product/spots.do', params, 'get');

/**
 * 视频专辑：导游详情视频专辑列表
 * */
export const getGuideVideos = params => fetch('product/guideBags.do', params, 'get');

/**
 * 自定义弹窗
 * */
export const getRichTxt = params => fetch('mini3/checkUserInScenic.do', params, 'get');

/**
 * 是否开启激活码
 * */
export const checkShopIsOTA = params => fetch('mini3/checkShopIsOTA.do', params, 'get');

/**
 * 是否显示开通会员功能
 * */
export const needMember = params => fetch('authChannel/needMember.do', params, 'post');

/**
 * 获取用户是否是会员
 * */
export const userIsVip = params => fetch('mini3/getUserInfo.do', params, 'post');

/**
 * 景区查询是否存在关联景区
 * */
export const siteBrother = params => fetch('site/hasBrother.do', params, 'get');

/**
 * 查看更多查询当前关联语音包
 * */
export const siteMore = params => fetch('site/more.do', params, 'get');

/**
 * 获取语音包VR列表 vmodel = 1
 * */
export const siteVrlist = params => fetch('site/vrlist.do', params, 'get');

/**
 * 获取语音包VR列表 vmodel = 2/3
 * */
export const siteVrlist2 = params => fetch('site/vrlist2.do', params, 'get');

/**
 * 获取语音包VR列表 vmodel = 4
 * */
export const siteVrlist3 = params => fetch('site/vrlist3.do', params, 'get');

/**
 * 判断是否弹出扫码提示
 * */
export const ScanTip = params => fetch('site/tips.do', params, 'get');

/**
 * 判断是否弹出扫码提示
 * */
export const bundlePrice = params => fetch('bundle/price.do', params, 'post');


//单个景点语音购买(购买页面价格结算)
export const spotBuyDetail = params => fetch('spotbuy/detail.do', params, 'post');
//单个景点语音购买(购买页面勾选点位计算价格)
export const spotBuyPrice = params => fetch('spotbuy/price.do', params, 'post');
//单个景点语音购买(专辑详情页)
export const spotBuygetVoiceBagDetail = params => fetch('spotbuy/getVoiceBagDetail.do', params, 'post');
//判断用户是否已经激活过
export const isMembered = params => fetch('isMembered.do', params, 'post');


//视频页面
export const videoCList = params => fetch('video/copy/list.do', params, 'post');
//视频详情
export const videoCDesc = params => fetch('video/copy/detail.do', params, 'post');
//视频推荐
export const videoCList2 = params => fetch('video/copy/list2.do', params, 'post');
//视频推荐
export const videoCListen = params => fetch('video/copy/listen.do', params, 'post');
//免费景区
export const freeList = params => fetch('mini3/freeList.do', params, 'post');

//中转页面
export const activate = params => fetch('api/activate.do', params, 'post');

//中秋抗疫活动  判断是否领取
export const isReceive = params => fetch('h5member/isReceive.do', params, 'get');
//中秋抗疫活动  领取
export const getReceive = params => fetch('h5member/receive.do', params, 'post');

//一图游——栏目
export const mapTabs = params => fetch('onemap/tabs.do', params, 'get');
//一图游——获取所有景点
export const mapShopSpot = params => fetch('onemap/getShopSpot.do', params, 'post');
//一图游——获取景点详情
export const mapSpotDetail = params => fetch('onemap/spotDetail.do', params, 'post');
//一图游——获取所有语音列表
export const mapVoice = params => fetch('onemap/voice.do', params, 'post');
//一图游——获取所有线路
export const mapRoutes = params => fetch('onemap/routes.do', params, 'post');
//一图游——获取线路所有景点
export const mapSiteSpots = params => fetch('onemap/siteSpots.do', params, 'post');
//一图游——服务场所列表
export const mapService = params => fetch('onemap/service.do', params, 'post');
//一图游——服务场所详情
export const mapServiceDetail = params => fetch('onemap/serviceDetail.do', params, 'post');
//一图游——景点评价
export const mapSpotComment = params => fetch('onemap/getComment.do', params, 'post');
//一图游——景区评价
export const mapViewComment = params => fetch('onemap/getComment2.do', params, 'post');
//一图游——上传评论
export const mapComment = params => fetch('onemap/comment2.do', params, 'post');

//AR激活——获取用户是否已经激活过
export const arUserIsActive = params => fetch('arshare/userIsActive.do', params, 'post');

//AR激活——获取ar场景列表
export const arList = params => fetch('arshare/arList.do', params, 'post');

//AR激活——获取已经激活的列表
export const arUserActiveList = params => fetch('arshare/userActiveList.do', params, 'post');

//AR激活——ar项点击
export const arClick = params => fetch('arshare/arClick.do', params, 'post');


//提交用户数据******* 其他方式授权
export const userinfoLogin = params => fetch('userinfoLogin.do', params, 'get');
//订单查询功能
export const checkDYorder = params => fetch('wap/checkDYorder.action', params, 'get');
//第三方签名
export const efzSign = params => fetch('efz/sign.wap', params, 'post');
//第三方授权获取用户信息
export const efzGetUserInfo = params => fetch('efz/getUserInfo.wap', params, 'post');


//获取VR视频的音频数据
export const getvoicebagdetail2 = params => fetch('getVoiceBagDetail2.do', params, 'get');
//获取当前视频锚点列表
export const getVrmaoList = params => fetch('vrshare/maoList.do', params, 'get');
//锚点事件点击提交
export const getVrmaoUpload = params => fetch('vrshare/maoUpload.do', params, 'get');


//提现公告
export const basetxnotice2 = params => fetch('basetxnotice2.do', params, 'get');
//非发票提现时获取实际金额
export const getActualMoney = params => fetch('money.do', params, 'get');

//导览详情
export const getTourinfo = params => fetch('shop/v2/tourinfo.do', params, 'get');
//封面详情
export const getCoverinfo = params => fetch('shop/v2/coverinfo.do', params, 'get');



// WEBPACK FOOTER //
// ./src/service/getData.js